module.exports = "::ng-deep .popover {\n  width: auto !important; }\n\n.mg-btm-20 {\n  margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/edit/session-edit.component.scss
// module id = ./src/app/modules/sessions/edit/session-edit.component.scss
// module chunks = main